import { useEffect, useMemo, useState } from 'react'
import { ThemeProvider as MuiThemeProvider, useMediaQuery } from '@mui/material'
import AgDataGridThemeProvider from '~/components/cms/data/AgDataGridThemeProvider'
// import { usePersistedStorage } from '~/hooks'
import ColorModeContext from './ColorModeContext'
import createTheme, { ThemeMode } from './themes'

const ThemeProvider = (props: object) => {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)')

  // const [mode, setMode] = usePersistedStorage(
  //   'theme',
  //   prefersDarkMode ? ThemeMode.Dark : ThemeMode.Light
  // )
  const [mode, setMode] = useState(
    prefersDarkMode ? ThemeMode.Dark : ThemeMode.Light
  )

  const colorMode = useMemo(
    () => ({
      toggle: () => {
        setMode(mode === ThemeMode.Light ? ThemeMode.Dark : ThemeMode.Light)
      },
    }),
    [mode, setMode]
  )

  const theme = useMemo(() => createTheme(mode as ThemeMode), [mode])

  useEffect(() => {
    if (mode === 'dark') {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }, [mode])

  return (
    <ColorModeContext.Provider value={colorMode}>
      <AgDataGridThemeProvider theme={theme}>
        <MuiThemeProvider theme={theme} {...props} />
      </AgDataGridThemeProvider>
    </ColorModeContext.Provider>
  )
}

export default ThemeProvider
